import { client } from "@/shared/api/pref-storage";
import { FilterNotifications } from "@/types/notifications";

// Types matching the OpenAPI spec
export interface TagsWatchlist {
  id: number;
  name: string;
  tags: string[];
  notifications?: FilterNotifications;
  owner_type: "USER" | "NEWSQUAWK" | "EXTERNAL";
}

export interface TagsWatchlistCreate {
  name: string;
  tags: string[];
  notifications?: FilterNotifications;
  owner_type?: "USER" | "NEWSQUAWK" | "EXTERNAL";
}

export interface TagsWatchlistUpdate {
  name?: string;
  tags?: string[];
  /** When sent, replaces the whole backend-source map — always send the complete map. */
  notifications?: FilterNotifications;
}

const endpoints = {
  tagsWatchlists: "/tags-watchlists",
  tagsWatchlist: (id: number) => `/tags-watchlists/${id}`,
};

export const getTagsWatchlists = (offset: number = 0, limit: number = 100) => {
  return client.get<TagsWatchlist[]>(endpoints.tagsWatchlists, {
    params: { offset, limit },
  });
};

export const createTagsWatchlist = (data: TagsWatchlistCreate) => {
  return client.post<TagsWatchlist>(endpoints.tagsWatchlists, data);
};

export const getTagsWatchlist = (id: number) => {
  return client.get<TagsWatchlist>(endpoints.tagsWatchlist(id));
};

export const updateTagsWatchlist = (id: number, data: TagsWatchlistUpdate) => {
  return client.patch<TagsWatchlist>(endpoints.tagsWatchlist(id), data);
};

export const deleteTagsWatchlist = (id: number) => {
  return client.delete(endpoints.tagsWatchlist(id));
};
